import React from 'react'
import { Modal } from '@web/walter-ui-kit'
import Content from './Content'

interface Props {
    isOpen: boolean
    onClose: () => void
    view: 'success' | 'pending' | 'error'
}

function StatusModal({ isOpen, onClose, view }: Props) {
    return (
        <Modal
            type="dialog"
            withHeaderBorder={false}
            onClose={onClose}
            isOpen={isOpen}
            dataPointer="status_modal"
            size="xs"
        >
            <Content onClose={onClose} view={view} />
        </Modal>
    )
}

export default StatusModal
